export default "__VITE_ASSET__e1caf2a0__"